// @flow
import React, { PureComponent } from "react";

type $props = {
  children?: any,
  className?: string
};

export default class UL extends PureComponent {
  props: $props;
  render() {
    const { children, ...props } = this.props;
    return <ul {...props}>{children}</ul>;
  }
}
